// extracted by mini-css-extract-plugin
export default {"wrapper":"primary_wrapper__-N7KY","main":"primary_main__Ltsg7","bottom":"primary_bottom__Efkat"};